export default __webpack_public_path__ + "asset/portugal.62d710dc0f6df6a2b1a087241b79d954.svg";